<template>
  <v-dialog v-model="dialogVisible" max-width="900px">
      <v-card>
          <v-card-title>
              <span class="headline">{{
                  isEdited
                      ? $t("translations.edit_translation")
                      : $t("translations.add_translation")
              }}</span>
          </v-card-title>
          <v-card-text>
              <v-container>
                  <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                          <v-col cols="12">
                              <v-text-field
                                  v-model="formData.key"
                                  :label="$t('translations.section_key')"
                                  :rules="keyRules"
                                  required
                              ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                              <v-textarea
                                  v-model="formData.value"
                                  :label="$t('translations.default_value')"
                                  :rules="valueRules"
                                  required
                                  :rows="2"
                                  auto-grow
                              ></v-textarea>
                          </v-col>
                          <v-col cols="12" v-for="lang in filteredLanguages" :key="lang.code">
                              <v-textarea
                                v-model="formData[`value_${lang.code}`]"
                                :label="lang.name + ' (' + lang.code + ')'"
                                :rows="2"
                                auto-grow
                              ></v-textarea>
                          </v-col>
                      </v-row>
                  </v-form>
              </v-container>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog">
                  {{ $t("general.cancel") }}
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="saveTranslation"
                  :disabled="!valid"
              >
                  {{ $t("general.save") }}
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      translation: {
          type: Object,
          required: true,
      },
      languages: {
          type: Array,
          required: true,
      },
      visible: {
          type: Boolean,
          default: false,
      },
      isEdited: {
          type: Boolean,
          default: false,
      },
  },

  data() {
      return {
          valid: true,
          formData: {
              key: "",
              value: ""
          },
          keyRules: [
              (v) => !!v || this.$t("validations.section_key_required"),
              (v) =>
                  (v && v.length <= 255) ||
                  this.$t("validations.section_key_max_length"),
          ],
          valueRules: [
              (v) => !!v || this.$t("validations.default_value_required"),
          ],
      };
  },

  computed: {
    filteredLanguages() {
      return this.languages.filter(l => l.code !== 'cz');
    },
    dialogVisible: {
        get() {
            return this.visible;
        },
        set(value) {
            if (!value) {
                this.$emit("close");
            }
        },
    },
  },

  watch: {
      visible(val) {
          if (val) {
              if (this.isEdited) {
                  this.formData = JSON.parse(JSON.stringify(this.translation));
              } else {
                  this.resetForm();
              }
          }
      },
      languages(newLangs) {
          if (newLangs.length > 0) {
              
              const formData = { ...this.formData };
              
              newLangs.forEach(lang => {
                  const fieldName = `value_${lang.code}`;
                  if (!formData[fieldName]) {
                      formData[fieldName] = '';
                  }
              });
              
              this.formData = formData;
          }
      }
  },

  methods: {
      resetForm() {
          const formData = {
              key: "",
              value: ""
          };
          
          this.languages.forEach(lang => {
              formData[`value_${lang.code}`] = '';
          });
          
          this.formData = formData;
          
          if (this.$refs.form) {
              this.$refs.form.resetValidation();
          }
      },

      closeDialog() {
          this.$emit("close");
          this.resetForm();
      },

      async saveTranslation() {
          if (this.$refs.form.validate()) {
              try {
                  if (this.isEdited) {
                      await this.updateTranslation();
                  } else {
                      await this.createTranslation();
                  }
                  this.closeDialog();
              } catch (error) {
                  console.error(error.response?.data || error);
                  this.$emit(
                      "snackMessage",
                      "general.error",
                      "error"
                  );
              }
          }
      },

      async createTranslation() {
          const response = await axios.post(
              "/translations",
              this.formData,
              {
                  headers: {
                      Authorization:
                          "Bearer " +
                          this.$store.state.tokenData.user.access_token,
                  },
              }
          );
          
          this.$emit("addTranslation", response.data);
          this.$emit(
              "snackMessage",
              "translations.created_successfully",
              "success"
          );
      },

      async updateTranslation() {
          const response = await axios.put(
              `/translations/${this.translation.id}`,
              this.formData,
              {
                  headers: {
                      Authorization:
                          "Bearer " +
                          this.$store.state.tokenData.user.access_token,
                  },
              }
          );
          
          this.$emit("updateTranslation", response.data.translation);
          this.$emit(
              "snackMessage",
              "translations.updated_successfully",
              "success"
          );
      },
  },
};
</script>